import PropTypes from 'prop-types';
import React from 'react';

import * as S from './Breadcrumb.styles';

export const BreadcrumbAppearance = {
  PRIMARY: 'primary',
  MINIMAL: 'minimal',
};

export const Breadcrumb = ({
  appearance = BreadcrumbAppearance.PRIMARY,
  currentPageName,
  homepageName,
  homepageUrl,
  parentList,
}) => {
  if (!currentPageName || !parentList || !homepageName || !homepageUrl) {
    return null;
  }

  return (
    <S.StyledBreadcrumb>
      <S.PageLink appearance={appearance} isHomeLink={true} href={homepageUrl}>
        {homepageName}
      </S.PageLink>
      <S.StyledChevron appearance={appearance} />
      {parentList &&
        parentList.map((parent, index) => {
          const url = parent.parentUid || '';
          const name = parent.parentName || '';

          if (!url || !name) {
            return null;
          }

          return (
            <>
              <S.PageLink
                appearance={appearance}
                key={`${parent}-${index}`}
                href={url}
              >
                {name}
              </S.PageLink>
              <S.StyledChevron appearance={appearance} />
            </>
          );
        })}
      <S.PageName appearance={appearance}>{currentPageName}</S.PageName>
    </S.StyledBreadcrumb>
  );
};

Breadcrumb.propTypes = {
  /**
   * Appearance of the breadcrumb.
   */
  appearance: PropTypes.oneOf(Object.values(BreadcrumbAppearance)),
  /**
   * Name of the current page.
   */
  currentPageName: PropTypes.string.isRequired,
  /**
   * Name of the root page.
   */
  homepageName: PropTypes.string.isRequired,
  /**
   * Link of the root page.
   */
  homepageUrl: PropTypes.string.isRequired,
  /**
   * List of pages between the root page
   * and the current one.
   */
  parentList: PropTypes.arrayOf(
    PropTypes.shape({
      parentLang: PropTypes.string,
      parentName: PropTypes.string,
      parentType: PropTypes.string,
      parentUid: PropTypes.string,
    })
  ).isRequired,
};
